import React from "react";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <div className="row justify-content-center hero-unit">
      <div className="col-xl-11">
        <div className="row">
          <div className="hero-cta">
            <h1>Southern California&apos;s Top Pavingstone Provider</h1>
            <Link to="/contact-us">
              <button className="button-main button-blue">
                Get a Free Estimate
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
